import React from 'react';
import PropTypes from 'prop-types';
import AdminSettings from './AdminSetting';

const SystemSettingsAtam = props => {
  const { settings, save } = props;
  const values = {
    interval_drones: settings.interval_drones,
    interval_uavos: settings.interval_uavos,
    iff_enabled: settings.iff_enabled,
  };

  return (
    <AdminSettings
      key="ATAM"
      save={save}
      valuesInit={values}
      settingTitle="ATAM"
    />
  );
};

SystemSettingsAtam.propTypes = {
  settings: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
};
export default SystemSettingsAtam;
